import { render, staticRenderFns } from "./editEmpty.vue?vue&type=template&id=36784adc"
import script from "./editEmpty.vue?vue&type=script&lang=js"
export * from "./editEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports